// extracted by mini-css-extract-plugin
export default {"option":"Options_option__dod6I","opt":"Options_opt__iTmKl"};